import { Fragment } from 'react';

import SelfAuthentication from './Components/Basic';

const Self = () => (
  <Fragment>
    {/* <!-- content 시작 --> */}
    <h2 className='screen_out'>환자정보확인</h2>
    <div id='mainContent' className='doc-main' role='main'>
      <SelfAuthentication />
    </div>

    {/* <!-- content 끝 --> */}
  </Fragment>
);

export default Self;
